import React, { useEffect, useState } from "react";
import {getAuthorization} from "../../../../axios/AxiosAut";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../../../table/Table"; // new
import { setProductBOM, SetCurrentID } from "../../../../redux/slices/item/itemSlice";
import { useDispatch, useSelector } from "react-redux";

function BOM(ID) {
  const [Items, setItems] = useState();
  const ProductBOM = useSelector((state) => state.item.ProductBOM);
  const CurrentID = useSelector((state) => state.item.CurrentID);
  const ItemDetails = useSelector((state) => state.item.ItemDetails);

  const dispatch = useDispatch();

  const getProductBOMdata = () => {
    getAuthorization()
      .get(`product/bom/${ID.Id}/`)
      .then((res) => {
        setItems(res.data.bom_item);
        dispatch(setProductBOM(res.data.bom_item));
        dispatch(SetCurrentID(ID.Id));

      })
      .catch((err) => [console.log("err", err)]);
  };

  useEffect(() => {

    if (ProductBOM.length === 0 || CurrentID !== ItemDetails.id) {
      getProductBOMdata();
      console.log("API called.....ItemsBOM");
      console.log("id  r..", ID.id);

    }

  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Item Name",
        accessor: "item.name",
        // Cell: StatusPill,
      },
      {
        Header: "Product ID",
        accessor: "item.product_id",
      },
      {
        Header: "Description",
        accessor: "item.description",
      },
    ],
    []
  );
  console.log("Items", Items);
  return (
    <div className="">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-3">
          <Table
            columns={columns}
            data={ProductBOM == undefined ? [] : ProductBOM}
            text="BOM"
          />
        </div>
      </main>
    </div>
  );
}

export default BOM;
